// extracted by mini-css-extract-plugin
module.exports = {"icon":"CartButton_icon__JQr_6"};